import type { Resource, ResourceRequirement, Service } from '@clinic/contracts';
import { fa } from '../../../shared/i18n/fa';

/** First free resource of each required kind/category (the user can change the choice). */
export function pickResources(service: Service | undefined, resources: readonly Resource[]): string[] {
  const chosen: string[] = [];
  for (const req of service?.resourceRequirements ?? []) {
    const match = resources.find(
      (r) => r.kind === req.kind && (req.category === null || r.category === req.category) && !chosen.includes(r.id),
    );
    if (match) chosen.push(match.id);
  }
  return chosen;
}

export function requirementLabel(req: ResourceRequirement): string {
  return fa.calendar.requirement(fa.settings.resources.kinds[req.kind], req.category);
}
